import { createContext, useContext } from 'react';
import { SubscriptionQuantityContextType } from './type/propTypes';

const SubscriptionQuantityContext = createContext<SubscriptionQuantityContextType | undefined>(undefined);
const useSubscriptionQuantityContext = () => useContext(SubscriptionQuantityContext);

export { SubscriptionQuantityContext, useSubscriptionQuantityContext };
export type { SubscriptionQuantityContextType };
